import { Action, ActionReducer } from '@ngrx/store';
import { merge, pick } from 'lodash-es';
import { StoreService } from '../shared/services/store.service';

export function storageMetaReducer<S, A extends Action = Action>(
    saveKeys: string[],
    localStorageKey: string,
    storageService: StoreService,
) {
    let onInit = true;
    return (reducer: ActionReducer<S, A>) => {
        return (state: S, action: A) => {
            const nextState = reducer(state, action);

            if (onInit) {
                onInit = false;
                const savedState = storageService.getSavedState(localStorageKey);

                return merge(nextState, savedState);
            }

            // save the next state to the application storage.
            const stateToSave = pick(nextState, saveKeys);
            const encryptedId = stateToSave?.aumicoAnnualReportMicroservice?.activeAnnualReportEncryptedId;
            const projectsOverview = stateToSave?.aumicoProjectsOverviewFeature;
            const filteredStateToSave = {
                ...stateToSave,
                // Keeps short-lived UI state out of localStorage. activeProjectId must stay:
                // Closing Workflow and Mandate Management have no project id in the URL and read
                // it from there.
                ...(projectsOverview
                    ? {
                          aumicoProjectsOverviewFeature: {
                              ...projectsOverview,
                              loading: false,
                              error: null,
                              pendingDependencyWarnings: [],
                          },
                      }
                    : {}),
                aumicoAnnualReportMicroservice: {
                    activeAnnualReportEncryptedId: encryptedId,
                    previousAnnualReportId: stateToSave.aumicoAnnualReportMicroservice?.previousAnnualReportId,
                    annualReportForAutoFillId: stateToSave.aumicoAnnualReportMicroservice?.annualReportForAutoFillId,
                    annualReportForUploadAndMappingAutoFillId:
                        stateToSave.aumicoAnnualReportMicroservice?.annualReportForUploadAndMappingAutoFillId,
                    annualReportToCopyNotesStructureFrom: null,
                    balanceFinancialStatementSource: null,
                    incomeFinancialStatementSource: null,
                    selectedMetaInformationId: stateToSave.aumicoAnnualReportMicroservice?.entities[encryptedId],
                    annualReportForUploadAndMappingAutoFill: null,
                    activeAnnualReport: null,
                    annualReportForAutoFill: null,
                    printView: null,
                    placeholders: {},
                    annualReportsListToCopyFrom: [],
                    ids: [],
                    entities: {
                        [encryptedId]: stateToSave.aumicoAnnualReportMicroservice?.entities[encryptedId],
                    },
                },
            };

            storageService.setSavedState(filteredStateToSave, localStorageKey);

            return nextState;
        };
    };
}
